import { html } from 'lit'
import HedeliusBaseItem from '../base-item.js'

customElements.define(
    'hedelius-left-item-model-range',
    class HedeliusLeftItemModelRange extends HedeliusBaseItem {
        static properties = {
            isActive: { type: Boolean, reflect: true },
        }

        renderAnchor() {
            return html`
                <li
                    class="${this.isActive
                        ? '!border-black'
                        : ''} flex flex-1 border-b-[2px] border-white transition-all"
                >
                    ${this.node.children.length > 0
                        ? html` <button
                              @click="${(e) => this._handleClick(e, this.node)}"
                              class="flex flex-1 flex-col py-8 pr-5 text-left text-xl leading-none md:!font-semibold"
                          >
                              ${this.node.title}
                              <span class="pt-3 text-base font-light">
                                  ${this.node.subtitle ? this.node.subtitle : ''}
                              </span>
                          </button>`
                        : html`
                              <a
                                  @click="${(e) => this._handleClick(e, this.node)}"
                                  class="flex flex-1 flex-col py-8 pr-5 text-xl leading-none md:!font-semibold"
                                  href="${this.node.href}"
                              >
                                  ${this.node.title}
                                  <span class="pt-3 text-base font-light">
                                      ${this.node.subtitle ? this.node.subtitle : ''}
                                  </span>
                              </a>
                          `}
                </li>
            `
        }
    }
)
